import React, { Component } from 'react'
import { DialogContainer } from 'react-md'
import { Field, reduxForm } from 'redux-form'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import {
  required,
  minLength,
  maxLength,
  mediumPassword,
  strongPassword
} from 'lib/validation'
import { TextField } from 'components'
import * as actions from 'redux/actions'
import * as routes from 'routes'

import './index.css'

const minLength8 = minLength(8)
const maxLength50 = maxLength(50)

const validate = values => {
  const errors = {}

  if (values.newPassword !== values.confirmNewPassword) {
    errors.confirmNewPassword = 'These passwords don\'t match'
  }

  return errors
}

class ResetPassword extends Component {
  constructor (props) {
    super(props)

    this.goBack = this.goBack.bind(this)
    this.closeDialog = this.closeDialog.bind(this)
  }

  goBack () {
    const { history } = this.props
    history.push(routes.signIn())
  }

  closeDialog () {
    this.goBack()
  }

  render () {
    const { visible, handleSubmit } = this.props
    return (
      <DialogContainer
        id='reset-password-dialog'
        visible={visible}
        onHide={this.closeDialog}
        title='Reset Password'
        dialogClassName='reset-password-dialog'
        actions={[{
          onClick: handleSubmit,
          primary: true,
          label: 'Save'
        }]}
        defaultVisibleTransitionable
        disableScrollLocking
        portal
      >
        <form onSubmit={handleSubmit}>
          <Field
            id='new-password'
            name='newPassword'
            label='New Password'
            placeholder='Enter your password'
            type='password'
            component={TextField}
            validate={[ required, minLength8, maxLength50, mediumPassword ]}
            warn={[ strongPassword ]}
            required
          />
          <Field
            id='confirm-new-password'
            name='confirmNewPassword'
            label='Confirm New Password'
            placeholder='Enter your password again'
            type='password'
            component={TextField}
          />
          <button type='submit' style={{display: 'none'}} />
        </form>
      </DialogContainer>
    )
  }
}

const ResetPasswordForm = reduxForm({
  form: 'resetPassword',
  validate
})(ResetPassword)

export default withRouter(connect(null, actions)(ResetPasswordForm))



// WEBPACK FOOTER //
// ./src/containers/Home/ResetPassword/index.js